export const environment = {
  production: true,
  apiUrl: '',
  email: null,
  password: null,
};
